'use strict';

angular.module('ntmApp').factory('RoomDetailsViewModel', ['$q', 'DailyPlanService', 'RoomInstructions', 'DailyPlanResourcePool', 'FlashService', 'Utils', 'DailyPlanConfirmationService',
                                 'DragFromResourcePool', 'DraggingToResourcePoolActions', 'DragStaffIntoResourcePool', 'DragActivitySequence', 'Constants', 'NonDailyActivities', 'SignalR',
                                 'ElementIdHelper',
    function ($q, DailyPlanService, RoomInstructions, DailyPlanResourcePool, FlashService, Utils, DailyPlanConfirmationService,
              DragFromResourcePool, DraggingToResourcePoolActions, DragStaffIntoResourcePool, DragActivitySequence, Constants, NonDailyActivities, SignalR,
              ElementIdHelper) {

        function RoomDetailsViewModel(context) {

            var self = this;

            var ConversionFactor = {
                seconds: 1 / 60,
                minutes: 1,
                hours: 60
            };

            self.activityType = Constants.ActivityTypes;

            self.activityStatuses = context.TopBar.activityStatuses;

            var RoomActivityChangedProperty = {
                metricDuration: function (activity, value) {

                    var conversionFactor = ConversionFactor[activity.durationUnit || 'minutes'];
                    if (conversionFactor !== undefined) {
                        activity.totalDuration = parseFloat((parseFloat(value) * activity.quantity * conversionFactor));
                    }
                },
                totalDuration: function (activity, value) {

                    var conversionFactor = ConversionFactor[activity.durationUnit || 'minutes'];

                    if (conversionFactor !== undefined) {
                        activity.metricDuration = activity.quantity > 0 ? ((parseFloat(value) / (activity.quantity * conversionFactor))) : parseFloat(0);
                    }
                }
            };

            self.RowActions = {
                cancelActivity: { value: 1, name: 'Cancel Activity', icon: 'Grid-Setup-Delete-Selectedui-24px-outline.svg' }
            };

            self.load = function () {

                self.isLoading = true;

                self.RoomInstructions.load();

                if (!self.ResourcePool.initialized) {
                    self.ResourcePool.load();
                }

                $q.all([loadActivities()]).then(function () {
                    self.isLoading = false;
                });

                self.NonDailyActivities.load();
            };

            self.editRoomActivities = function () {
                setEditMode();
            };

            self.saveRoomActivities = function () {

                var request = context.getViewModeSelectedDateAndRoomInfo();
                request.scheduleDurations = [];

                self.roomActivities.forEach(function (roomActivity) {

                    var originalGroup = self.roomActivitiesOriginal.firstOrDefault(function (original) {
                        return original.name === roomActivity.name;
                    });

                    if (originalGroup) {

                        roomActivity.items.forEach(function (item) {

                            var originalActivity = originalGroup.items.firstOrDefault(function (activity) {
                                return item.scheduleId === activity.scheduleId;
                            });

                            if (originalActivity && item.totalDuration !== originalActivity.totalDuration) {

                                request.scheduleDurations.push({
                                    scheduleId: item.scheduleId,
                                    metricDuration: item.metricDuration,
                                    totalMinutes: item.totalDuration
                                });
                            }
                        });
                    }
                });


                var loadingModal = FlashService.Loading();
                DailyPlanService.SaveRoomActivities(request).then(function (result) {

                    if (result.success) {
                        self.roomActivitiesOriginal = angular.copy(self.roomActivities);
                        setViewMode();

                        $q.all([loadRoomDetails(), self.ResourcePool.load()])
                          .then(function () {
                              loadingModal.dismiss();
                          });

                        FlashService.Success(result.data.message);
                    } else {
                        loadingModal.dismiss();
                    }
                });

            };

            self.cancelRoomActivities = function () {

                var cancelRoomActivitiesAction = function () {
                   
                    self.roomActivities.forEach(function (group) {

                        var originalGroup = self.roomActivitiesOriginal.firstOrDefault(function (original) {
                            return original.name === group.name;
                        });

                        if (originalGroup) {

                            group.items.forEach(function (activity) {

                                var originalActivity = originalGroup.items.firstOrDefault(function (item) {
                                    return item.scheduleId === activity.scheduleId;
                                });

                                if (originalActivity && activity.totalDuration !== originalActivity.totalDuration) {
                                    activity.totalDuration = originalActivity.totalDuration;
                                }
                            });

                            group.groupingSummaries = getGroupingStaffSummaries(group);
                        }
                    });

                    setViewMode();
                };

                if (self.isActivitiesGridChanged()) {
                    DailyPlanConfirmationService.YesNoConfirmation("Are you sure you want to cancel duration changes?")
                                       .Yes(cancelRoomActivitiesAction)
                                       .Ask();
                } else {
                    setViewMode();
                }

            };

            self.totalRoomActivityMinutes = function (roomActivity) {

                if (roomActivity && roomActivity.items) {
                    return roomActivity.items.reduce(function (sum, item) {
                        return (sum || 0) + parseFloat(item.totalDuration) || 0;
                    }, 0);
                }

                return 0;
            };

            self.totalRoomActivityStatusIcon = function (roomActivity) {
                if (roomActivity && roomActivity.items) {

                    if (context.TopBar.isPastDateDisplayed()) {
                        if (roomActivity.items.length === roomActivity.items.filter(function (item) { return item.activityStatusId === self.activityStatuses[2].id; }).length) {
                            return self.activityStatuses[2].icon;
                        }
                        else {
                            return self.activityStatuses[4].icon;
                        }
                    } else {

                        if (roomActivity.items.length === roomActivity.items.filter(function (item) { return item.activityStatusId === self.activityStatuses[0].id; }).length) {
                            return self.activityStatuses[0].icon;
                        } else if (roomActivity.items.length === roomActivity.items.filter(function (item) { return item.activityStatusId === self.activityStatuses[2].id; }).length) {
                            return self.activityStatuses[2].icon;
                        }
                        else {
                            return self.activityStatuses[1].icon;
                        }
                    }

                }
            };

            self.totalRoomActivityStatus = function (roomActivity) {
                if (roomActivity && roomActivity.items) {

                    if (context.TopBar.isPastDateDisplayed()) {
                        if (roomActivity.items.length === roomActivity.items.filter(function (item) { return item.activityStatusId === self.activityStatuses[2].id; }).length) {
                            return self.activityStatuses[2].value;
                        }
                        else {
                            return self.activityStatuses[4].value;
                        }
                    } else {

                        if (roomActivity.items.length === roomActivity.items.filter(function (item) { return item.activityStatusId === self.activityStatuses[0].id; }).length) {
                            return self.activityStatuses[0].value;
                        } else if (roomActivity.items.length === roomActivity.items.filter(function (item) { return item.activityStatusId === self.activityStatuses[4].id; }).length) {
                            return self.activityStatuses[4].value;
                        } else if (roomActivity.items.length === roomActivity.items.filter(function (item) { return item.activityStatusId === self.activityStatuses[2].id; }).length) {
                            return self.activityStatuses[2].value;
                        }
                        else {
                            return self.activityStatuses[1].value;
                        }
                    }

                }
            };

            self.resetRoomActivities = function (type) {

                var request = context.getViewModeSelectedDateAndRoomInfo();
                request.scheduleIds = [];

                self.roomActivities.forEach(function (group) {

                    var requestItems = group.items.filter(function (item) {
                        return (self.doesActivityStatusAllowActivityChanging(item.activityStatusId) || item.activityStatusId === Constants.ActivityStatus.Replaced);
                    });

                    requestItems.forEach(function (item) {
                        request.scheduleIds.push(item.scheduleId);
                    });
                });

                request.activityResetAction = type;

                var loadingModal = FlashService.Loading();
                DailyPlanService.ResetLocationActivities(request).then(function () {
                    reloadView(loadingModal);
                });
            };

            self.processGridRowAction = function (action, item) {
                var data = {};
                data.activityActionType = action.value;
                data.scheduleIds = [item.scheduleId];
                data.facilityCode = context.TopBar.BreadCrumbs.selectedRoom.facilityCode;
                data.roomNumber = context.TopBar.BreadCrumbs.selectedRoom.roomNumber;
                data.date = moment(context.TopBar.dateDisplayed);
                //activity Type==Room activity
                data.activityType = 0;

                var sendGridRowAction = function () {

                    var loadingModal = FlashService.Loading();
                    DailyPlanService.SetGridRowActions(data).then(function (result) {

                        $q.all([loadActivities(), self.ResourcePool.load()])
                          .then(function () {
                              loadingModal.dismiss();
                          });

                        FlashService.Success(result.data.message);
                    }).finally(function () {
                        loadingModal.dismiss();
                    });
                };

                switch (action.name) {
                    case 'Cancel Activity':
                        var confirmationMessage = self.doesActivityStatusAllowActivityChanging(item.activityStatusId) ? "Are you sure you want to cancel this activity?" : "This activity has already been marked " + item.activityStatus + ". Are you sure you want to cancel this activity?";

                        DailyPlanConfirmationService.YesNoConfirmation(confirmationMessage, null, { title: 'Cancel Activity', no: 'Never mind', yes: 'Yes, Cancel Activity' })
                                   .Yes(sendGridRowAction)
                                   .Ask();

                        break;
                }
            };

            self.totalRoomActivityHoursAllGroup = function () {

                if (self.roomActivities) {
                    return self.roomActivities.reduce(function (sum, item) {
                        return (sum || 0) + totalRoomActivityHours(item) || 0;
                    }, 0);
                }

                return 0;
            };

            self.totalRoomActivityHoursByPersonAllGroup = function (personId) {

                if (self.roomActivities) {

                    return self.roomActivities.reduce(function (sum, item) {
                        return (sum || 0) + totalRoomActivityHoursByPerson(item, personId) || 0;
                    }, 0);
                }

                return 0;
            };

            self.getMetricDurationStepValue = function (durationType, getValueType) {

                var spinerStep = 1;
                var roundTo = 1;

                switch (durationType) {
                    case 'seconds':
                        spinerStep = 1;
                        roundTo = 0;
                        break;
                    case 'minutes':
                        spinerStep = 0.1;
                        roundTo = 2;
                        break;
                    case 'hours':
                        spinerStep = 0.01;
                        roundTo = 2;
                        break;

                }

                if (getValueType === 'roundTo') {
                    return roundTo;
                } else if (getValueType === 'spinerStep') {
                    return spinerStep;
                }
            };

            self.expandAllRoomActivities = function () {
                self.roomActivities.forEach(function (roomActivity) {
                    roomActivity.expanded = true;
                });
            };

            self.collapseAllRoomActivities = function () {
                self.roomActivities.forEach(function (roomActivity) {
                    roomActivity.expanded = false;
                });
            };

            self.showUnplanedActivitiesButton = function (button) {


                if (!button.jsonProperties || !button.jsonProperties.display) {
                    return true;
                }

                return button.jsonProperties.display.level3;
            };

            self.toogleRoomInfo = function () {
                self.showRoomInfo = !self.showRoomInfo;
                self.showResourcePool = false;
                self.showNonDailyActivities = false;

                saveRightPanesState();
            };

            self.toggleResourcePool = function () {
                self.showResourcePool = !self.showResourcePool;
                self.showRoomInfo = false;
                self.showNonDailyActivities = false;

                saveRightPanesState();
            };

            self.toggleNonDailyActivities = function () {
                self.showNonDailyActivities = !self.showNonDailyActivities;
                self.showResourcePool = false;
                self.showRoomInfo = false;

                saveRightPanesState();
            };

            self.isRightPanelOpened = function () {
                return self.showRoomInfo || self.showResourcePool || self.showNonDailyActivities;
            };

            self.roomActivityChanged = function (activity, group, property) {

                if (angular.isNumber(activity.quantity) && angular.isNumber(parseFloat(activity[property]))) {

                    if (RoomActivityChangedProperty[property]) {
                        RoomActivityChangedProperty[property](activity, activity[property]);
                    }

                } else {
                    activity.totalDuration = null;
                }

                group.groupingSummaries = getGroupingStaffSummaries(group);
            };

            self.getInfoForDraggingAction = function () {

                var totalHours = 0;
                var changeableHours = 0;
                var unAssignedHours = 0;
                var activities = [];

                self.roomActivities.forEach(function (roomActivity) {

                    totalHours += roomActivity.totalHours;
                    changeableHours += roomActivity.changeableHours;
                    unAssignedHours += roomActivity.unAssignedHours;

                    roomActivity.items.forEach(function (item) {
                        if (self.doesActivityStatusAllowActivityChanging(item.activityStatusId)) {
                            activities.push({ assignmentId: item.assignmentId, activityStatusId: item.activityStatusId, duration: item.totalDuration, speciesId: item.speciesCode, speciesName: item.speciesName, activityId: item.activityId, activity: item.activity });
                        }
                    });
                });


                if (self.dndTarget && self.dndTarget.length > 0) {

                    return {
                        roomNumber: context.TopBar.BreadCrumbs.selectedRoom.roomNumber,
                        facilityCode: context.TopBar.BreadCrumbs.selectedRoom.facilityCode,
                        date: moment(context.TopBar.dateDisplayed),
                        isExistingAssignments: self.ResourcePool.replaceAssignments || false,
                        isSingleActivity: false,
                        totalHours: totalHours,
                        changeableHours: changeableHours,
                        unAssignedHours: unAssignedHours,
                        activities: activities
                    };
                }

                var activitiesGroup = self.roomActivities.firstOrDefault(function (group) {
                    return group.dndTarget && group.dndTarget.length > 0;
                });

                if (activitiesGroup) {

                    activities = [];
                    activitiesGroup.items.forEach(function (item) {
                        if (self.doesActivityStatusAllowActivityChanging(item.activityStatusId)) {
                            activities.push({ assignmentId: item.assignmentId, activityStatusId: item.activityStatusId, duration: item.totalDuration, speciesId: item.speciesCode, speciesName: item.speciesName, activityId: item.activityId, activity: item.activity });
                        }
                    });

                    return {
                        roomNumber: context.TopBar.BreadCrumbs.selectedRoom.roomNumber,
                        facilityCode: context.TopBar.BreadCrumbs.selectedRoom.facilityCode,
                        date: moment(context.TopBar.dateDisplayed),
                        groupName: activitiesGroup.name,
                        ccrackId: activitiesGroup.ccrackId,
                        isExistingAssignments: self.ResourcePool.replaceAssignments || false,
                        isSingleActivity: false,
                        totalHours: activitiesGroup.totalHours,
                        changeableHours: activitiesGroup.changeableHours,
                        unAssignedHours: activitiesGroup.unAssignedHours,
                        activities: activities
                        
                    };
                }

                var activitiesGroupWithTargetedActivity = self.roomActivities.firstOrDefault(function (group) {
                    return group.items.some(function (item) {
                        return item.dndTarget && item.dndTarget.length > 0;
                    });
                });

                if (activitiesGroupWithTargetedActivity) {

                    var activity = activitiesGroupWithTargetedActivity.items.firstOrDefault(function (item) {
                        return item.dndTarget && item.dndTarget.length > 0;
                    });

                    if (activity) {

                        return {
                            roomNumber: context.TopBar.BreadCrumbs.selectedRoom.roomNumber,
                            facilityCode: context.TopBar.BreadCrumbs.selectedRoom.facilityCode,
                            date: moment(context.TopBar.dateDisplayed),
                            groupName: activitiesGroupWithTargetedActivity.name,
                            ccrackId: activitiesGroupWithTargetedActivity.ccrackId,
                            scheduleId: activity.scheduleId,
                            activityName: activity.activity,
                            activityId: activity.activityId,
                            speciesId: activity.speciesCode,
                            speciesName: activity.speciesName,
                            totalHours: activity.totalDuration,
                            isExistingAssignments: self.ResourcePool.replaceAssignments || false,
                            isSingleActivity: true
                        };
                    }
                }

                return {};
            };

            self.updateViewOnWebSocketsResponse = function (callBackData) {

                var dateDisplayed = moment(context.TopBar.dateDisplayed).startOf('day');
                var socketDate = moment(callBackData.date).startOf('day');

                if (dateDisplayed.isSame(socketDate) && !self.EditMode) {

                    var currentRoomInfo = context.getRoomInfo();

                    var isRoomMatched = callBackData.dailySocketFacilities.some(function (facility) {
                        return currentRoomInfo.facilityCode === facility.facilityCode && facility.roomNumber === currentRoomInfo.roomNumber;
                    });

                    if (isRoomMatched) {
                        reloadView();
                    }
                }
            };

            self.filterPresentStaffByRoomSpecies = function () {
                var activities = [];
                self.roomActivities.forEach(function (item) {
                    activities = activities.concat(item.items);
                });

                self.ResourcePool.clearFilter(self.ResourcePool.Filter.BySkillSetFilter);
                self.ResourcePool.Filter.StaffSkillsFilter.filterItem = { value: "byRoom", title: "By Room Skills" };
                self.ResourcePool.Filter.ByRoomSkillsFilter.filterItem = { activities: activities };
                self.ResourcePool.Filter.ByRoomSkillsFilter.filterItem.id = context.TopBar.BreadCrumbs.selectedRoom.roomNumber;
                self.ResourcePool.Filter.ByRoomSkillsFilter.filterItem.value = context.TopBar.BreadCrumbs.selectedRoom.roomNumber;

                if (!self.showResourcePool) {
                    self.toggleResourcePool();
                }

                self.ResourcePool.performFiltering();
            };

            self.confirmViewLeaving = function (nextAction) {
               
                var saveAndContinue = function () {

                    if (self.EditMode || self.isActivitiesGridChanged()) {
                        self.saveRoomActivities();
                    }

                    if (self.forms && self.forms.infoForm && self.forms.infoForm.$dirty) {
                        self.RoomInstructions.saveRoomInformation(self.forms.infoForm);
                    }

                    if (nextAction) {
                        nextAction();
                    }
                };

                var continueWithoutSaving = function () {

                    if (self.EditMode || self.isActivitiesGridChanged()) {
                        self.cancelRoomActivities();
                    }

                    if (self.forms && self.forms.infoForm && self.forms.infoForm.$dirty) {
                        self.RoomInstructions.cancelRoomInformation(self.forms.infoForm);
                    }

                    if (nextAction) {
                        nextAction();
                    }
                };

                DailyPlanConfirmationService.Confirmation(getOnLeaveConfirmMessage())
                                   .Yes(saveAndContinue)
                                   .No(continueWithoutSaving)
                                   .Ask();
            };

            self.isChanged = function () {
                return self.isActivitiesGridChanged() ||
                       (self.forms.infoForm && self.forms.infoForm.$dirty);
            };


            self.isActivitiesGridChanged = function () {

                if (self.roomActivities) {

                    return self.roomActivities.some(function (group) {

                        var originalGroup = self.roomActivitiesOriginal.firstOrDefault(function (original) {
                            return original.name === group.name;
                        });

                        if (originalGroup) {

                            return group.items.some(function (activity) {

                                var originalActivity = originalGroup.items.firstOrDefault(function (item) {
                                    return item.scheduleId === activity.scheduleId;
                                });

                                if (originalActivity) {
                                    return activity.totalDuration !== originalActivity.totalDuration;
                                }

                                return false;
                            });
                        }

                        return false;
                    });
                }

                return false;
            };

            self.showCancelledActivitiesDialog = function (cancelledActivities) {

                var viewModeSelectedDateAndRoomInfo = context.getViewModeSelectedDateAndRoomInfo();

                var data = {
                    cancelledActivities: cancelledActivities,
                    date: viewModeSelectedDateAndRoomInfo.date,
                    isPastDateDisplayed: context.TopBar.isPastDateDisplayed(),
                    facilityCode: viewModeSelectedDateAndRoomInfo.facilityCode,
                    roomNumber: viewModeSelectedDateAndRoomInfo.roomNumber
                };

                var popup = Utils.OpenModal('', 'ng1/src/dailyPlan/views/dialogs/cancelledActivitiesDialog.html', 'cancelledActivitiesController', data, 'daily-plan-cancelled-activities-dialog', null, false);

                popup.result.then(function () {

                    var loadingModal = FlashService.Loading();

                    $q.all([loadActivities(), self.ResourcePool.load()])
                           .then(function () {
                               loadingModal.dismiss();
                               popup.dismiss();
                           });
                });
            };

            self.defaultDndTargets = function () {
                self.dndTarget = [];
                self.ResourcePool.dndTarget = [];

                if (self.roomActivities) {
                    self.roomActivities.forEach(function (record) {
                        record.dndTarget = [];

                        if (record.items) {
                            record.items.forEach(function (item) {
                                if (self.doesActivityStatusAllowActivityChanging(item.activityStatusId)) {
                                    item.dndTarget = [];
                                    item.dndType = record.name;
                                }
                            });
                        }
                    });
                }
            };

            self.doesActivityStatusAllowActivityChanging = function (activityStatusId) {
                return activityStatusId === Constants.ActivityStatus.NotStarted || activityStatusId === Constants.ActivityStatus.Lapsed;
            };

            self.openStaffNoteEditing = function (activity, groupName) {

                var data = {
                    selectedActivity: activity,
                    groupName: groupName
                };

                Utils.OpenModal('', 'ng1/src/dailyPlan/views/dialogs/staffNotesDialog.html', 'staffNotesController', data, 'staff-notes-dialog', null, false);
            };

            function getOnLeaveConfirmMessage() {

                if (self.EditMode && self.forms.infoForm && self.forms.infoForm.$dirty) {
                    return "Save pending duration changes and changes to Room Instructions?";
                }

                if (self.EditMode || self.isActivitiesGridChanged()) {
                    return "Save pending duration changes?";
                }

                if (self.forms.infoForm && self.forms.infoForm.$dirty) {
                    return "Save pending changes to Room Instructions?";
                }

                return "";
            }

            function loadRoomDetails() {

                var deferred = $q.defer();
                var request = context.getViewModeSelectedDateAndRoomInfo();

                DailyPlanService.GetRoomDetails(request).then(function (result) {

                    if (result.success) {
                        self.roomDetails = result.data;
                        self.roomDetails.rackCensusLable = self.roomDetails.rackCensusFlag ? 'Rack Census' : 'Room Census';
                        context.TopBar.BreadCrumbs.setRoomDetails(self.roomDetails);

                        self.roomDetails.assigneeStats.forEach(function (staff) {
                            if (self.roomActivities) {
                                self.roomActivities.forEach(function (group) {
                                    staff.hasChangeableActivities = staff.hasChangeableActivities || (group.groupingSummaries.filter(function (assignee) { return ((staff.personId === assignee.assigneeId) && (assignee.hasChangeableActivities)); }).length > 0) ? true : false;
                                });
                            }
                        });
                    }

                    deferred.resolve();
                });

                return deferred.promise;
            }

            function loadActivities() {

                var deferred = $q.defer();
                var request = context.getViewModeSelectedDateAndRoomInfo();

                DailyPlanService.GetRoomActivities(request).then(function (result) {

                    if (result.success) {
                        self.roomActivities = syncCollapsedExpandedState(self.roomActivities, result.data.roomActivityGroups);

                        self.roomActivities.forEach(function (group) {

                            group.items.forEach(function (activity) {
                                activity.elementClassName = ElementIdHelper.getActivityElementClassName(activity.scheduleId, activity.activityStatusId);
                            });

                            group.hasChangeableActivities = (group.items.filter(function (item) {
                                return self.doesActivityStatusAllowActivityChanging(item.activityStatusId);
                            }).length > 0) ? true : false;
                            group.groupingSummaries = getGroupingStaffSummaries(group);
                            group.icons = getUniqueIcons(group.items);
                        });

                        self.defaultDndTargets();

                        self.hasChangeableActivities = (self.roomActivities.filter(function (group) { return group.hasChangeableActivities === true; }).length > 0) ? true : false;

                        self.roomActivitiesOriginal = angular.copy(self.roomActivities);

                        self.cancelledRoomActivities = result.data.cancelledRoomActivities;

                        loadRoomDetails();
                    }

                    deferred.resolve();

                });

                return deferred.promise;
            }

            function getUniqueIcons(activities) {

                var icons = activities.filter(function (activity) {
                    return activity.activityIcon;
                }).map(function (activity) {
                    return {
                        icon: Constants.ActivityTypes.getIconSrc(activity),
                        color: Constants.ActivityTypes.getIconColor(activity.activityIcon)
                    };
                }).unique(function (icon1, icon2) {
                    return icon1.icon === icon2.icon &&
                           icon1.color === icon2.color;
                });

                return icons;
            }

            function reloadView(loadingModal) {

                loadingModal = loadingModal || FlashService.Loading();

                $q.all([loadActivities(), self.ResourcePool.load()])
                  .then(function () {
                      loadingModal.dismiss();
                  });
                self.NonDailyActivities.load();
            }

            function syncCollapsedExpandedState(previousActivitiesGroups, newActivitiesGroups) {

                if (previousActivitiesGroups) {

                    newActivitiesGroups.forEach(function (group) {

                        var previousGroup = previousActivitiesGroups.firstOrDefault(function (record) {
                            return record.name === group.name;
                        });

                        if (previousGroup) {
                            group.expanded = previousGroup.expanded;
                        }

                    });
                }

                return newActivitiesGroups;
            }

            function totalRoomActivityHoursByPerson(roomActivity, personId) {

                if (roomActivity && roomActivity.items) {
                    return roomActivity.items.reduce(function (sum, item) {
                        return (sum || 0) + (parseInt(personId) === parseInt(item.assignmentId) ? parseFloat(item.totalDuration) || 0 : 0);
                    }, 0);
                }

                return 0;
            }

            function totalRoomActivityHours(roomActivity) {
                return roomActivity.items.reduce(function (sum, item) {
                    return (sum || 0) + parseFloat(item.totalDuration) || 0;
                }, 0);
            }

            function getGroupingStaffSummaries (group) {
                var uniqueIds = Array.from(new Set(group.items.map(function (item) { return item.assignmentId; })));
                var groupedItems = [];

                uniqueIds.forEach(function (id) {
                    if (id !== null && id !== undefined) {
                        groupedItems.push(group.items.filter(function (item) { return item.assignmentId === id; }));
                    }
                });

                var groupingSummary = [];

                groupedItems.forEach(function (groupingItem) {
                    groupingSummary.push({
                        assigneeId: groupingItem[0].assignmentId ? groupingItem[0].assignmentId : null,
                        assigneeName: groupingItem[0].assignment ? groupingItem[0].assignment : null,
                        totalActivityDurations: groupingItem.sumOf('totalDuration'),
                        hasChangeableActivities: (groupingItem.filter(function (item) {
                            return self.doesActivityStatusAllowActivityChanging(item.activityStatusId);
                        }).length > 0) ? true : false
                    });
                });

                return groupingSummary;
            }

            function setViewMode() {
                self.EditMode = false;
            }

            function setEditMode() {
                self.EditMode = true;
            }

            function saveRightPanesState() {
                sessionStorage.showDailyPlanRoomInfo = self.showRoomInfo || "";
                sessionStorage.showDailyPlanResourcePoolPane = self.showResourcePool || "";
                sessionStorage.showDailyPlanNonDailyActivitiesPane = self.showNonDailyActivities || "";

                sessionStorage.showDailyPlanStatisticsPane = "";
            }

            function isDraggingAllowed() {

                if (self.EditMode) {
                    FlashService.Error('Please save or cancel duration changes before changing assignments.');
                    return false;
                }

                return true;
            }

            function onEndDragging() {

                if (SignalR.IsSupported()) {
                    self.defaultDndTargets();
                } else {
                    reloadView();
                }
            }

            function initialize() {

                self.RoomInstructions = new RoomInstructions(context);
                self.ResourcePool = new DailyPlanResourcePool(context);
                self.NonDailyActivities = new NonDailyActivities(context);

                self.DragFromResourcePool = new DragFromResourcePool(self);
                self.DragFromResourcePool.onStartDragging(function () {
                    if (isDraggingAllowed()) {
                        self.dragAllowed = true;
                        return true;
                    }

                    return false;
                });
                self.DragFromResourcePool.onEndDragging(onEndDragging);

                self.DragActivitySequence = new DragActivitySequence(context);

                self.DragStaffIntoResourcePool = new DragStaffIntoResourcePool(context);

                self.DragToResourcePool = new DraggingToResourcePoolActions([self.DragStaffIntoResourcePool]);
                self.DragToResourcePool.onEndDragging(onEndDragging);
                self.DragToResourcePool.onStartDragging(function () {

                    if (isDraggingAllowed()) {

                        if (!self.showResourcePool) {
                            self.toggleResourcePool();
                        }

                        self.ResourcePool.selectPresentStaffTab();

                        return true;
                    }

                    return false;
                });

                self.forms = {};
                self.EditMode = false;
                self.dndTarget = [];

                self.showResourcePool = sessionStorage.showDailyPlanResourcePoolPane ? true : false;
                self.showRoomInfo = sessionStorage.showDailyPlanRoomInfo ? true : false;
                self.showNonDailyActivities = sessionStorage.showDailyPlanNonDailyActivitiesPane ? true : false;

                if (self.showNonDailyActivities && self.showResourcePool) {
                    self.showNonDailyActivities = false;
                }
            }

            initialize();
        }

        return (RoomDetailsViewModel);

    }]);
